module.exports = __webpack_public_path__ + "static/media/tabs-icon-bookmark.a7d08ea9.svg";